import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NavArrow from '../NavArrow';
import Thumbnails from '../Thumbnails';
import Header from '../Header';
import { keyCode } from '../../../MediaViewer/Utils';
import CollaboratorNoUsernameAlert from '../CollaboratorNoUsernameAlert';
import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { NAVIGATION_BETWEEN_FILES } from '../../../Utils/mixpanel/mixpanelEvents';
import * as CurrentsActions from '../../actions/current';
import * as FilesSelectors from '../../selectors/files';
import * as FilerrsSelectors from '../../selectors/filerrs';
import * as CurrentsSelectors from '../../selectors/current';

import './style.scss';

class Navigation extends Component {

    constructor(props) {
        super(props);

        this.navigateByKeys = this.navigateByKeys.bind(this);
    }

    componentDidMount() {
        this.containerRef.addEventListener('keydown', this.navigateByKeys);

        if (this.containerRef.tabIndex < 0) {
            console.error( // eslint-disable-line no-console
                `missing tabIndex attribute on containerRef prop in <Navigation />.
                Keyboard navigation may not work properly.`
            );
        }

        setTimeout(() => {
            this.containerRef && this.containerRef.focus();
        }, 0);
    }

    componentWillUnmount() {
        this.containerRef.removeEventListener('keydown', this.navigateByKeys);
    }

    get containerRef() {
        return this.props.containerRef || this.root;
    }

    reportToMixpanel() {
        sendMixPanelEvent({
            eventName: NAVIGATION_BETWEEN_FILES,
            eventData: {
                'Navigation Source': 'Keyboard'
            }
        });
    }

    navigateByKeys(event) {
        if (!event) {
            return;
        }

        event.stopPropagation();

        const targetIsTextInput = ['input', 'textarea'].some(
            (type) => event.target.type === type
        );

        if (targetIsTextInput) {
            return;
        }

        const {
            onLeftClick,
            onRightClick
        } = this.props;

        switch (event.which) {
            case keyCode.ARROW_LEFT:
                onLeftClick();
                this.reportToMixpanel();
                break;

            case keyCode.ARROW_RIGHT:
                onRightClick();
                this.reportToMixpanel();
                break;

            default:
                break;
        }
    }

    render() {
        const {
            onLeftClick,
            onRightClick,
            children,
            showArrows,
            currentCollaboratorId,
            close
        } = this.props;

        return (
            <div className="navigation-wrapper" ref={(root) => this.root = root} tabIndex={1}>
                <Header close={close}/>
                <div className="navigation">
                    <NavArrow className={classNames('left', { 'v-hidden': !showArrows })} onClick={onLeftClick}/>
                    {children}
                    <NavArrow className={classNames('right', { 'v-hidden': !showArrows })} onClick={onRightClick}/>
                </div>
                <Thumbnails/>
                <CollaboratorNoUsernameAlert collaboratorId={currentCollaboratorId}/>
            </div>
        );
    }
}

Navigation.propTypes = {
    onLeftClick: PropTypes.func,
    onRightClick: PropTypes.func,
    showArrows: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    containerRef: PropTypes.object,
    currentCollaboratorId: PropTypes.string,
    close: PropTypes.func
};

Navigation.defaultProps = {
    onLeftClick: () => null,
    onRightClick: () => null,
    showArrows: true
};

const mapStateToProps = (state) => ({
    showArrows: FilerrsSelectors.isMoreThanOne(state),
    currentCollaboratorId: CurrentsSelectors.getCurrentCollaboratorId(state)
});

const mapDispatchToProps = (dispatch) => {
    const onLeftClick = () => (dispatch, getState) => {
        const filerrId = FilerrsSelectors.getPreviousFilerrId(getState());
        const fileId = FilesSelectors.getFileIdByFileFilerrId(getState(), filerrId);

        dispatch(CurrentsActions.setCurrentFileId(fileId));
        dispatch(CurrentsActions.setCurrentFilerrId(filerrId));
        dispatch(CurrentsActions.setCurrentCommentId());
        dispatch(CurrentsActions.setCurrentTimecode());
    };

    const onRightClick = () => (dispatch, getState) => {
        const filerrId = FilerrsSelectors.getNextFilerrId(getState());
        const fileId = FilesSelectors.getFileIdByFileFilerrId(getState(), filerrId);

        dispatch(CurrentsActions.setCurrentFileId(fileId));
        dispatch(CurrentsActions.setCurrentFilerrId(filerrId));
        dispatch(CurrentsActions.setCurrentCommentId());
        dispatch(CurrentsActions.setCurrentTimecode());
    };

    return {
        onLeftClick: () => dispatch(onLeftClick()),
        onRightClick: () => dispatch(onRightClick())
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Navigation);
